module.exports = __webpack_public_path__ + "media/images/minus_icon-75f348dc34da4d94c668e18d9a5e4e2e.svg";